/** @deprecated Quarantined legacy (WEB-8483) — moved out of the Angular tree so the ReactTemplates.mailCampaign global survives Phase 6. Do not import in new code. */
import { Row, Column, Icon, Tooltip } from '@upsales/components';
import { ThirdButton } from '@upsales/components/Buttons';
import T from 'Components/Helpers/translate';
import UpSelect from 'Components/Inputs/UpSelect';

const RecipientFilters = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = Tools.$translate;

		this.lang = {
			notDelivered: t('mail.notDelivered'),
			opened: t('mail.opened'),
			clicked: t('event.mailClicked'),
			submits: t('defaultView.formSubmit'),
			unsubs: t('mail.unsubscribers'),
			delivered: t('mail.delivered'),
			bounce: t('event.bounce'),
			prevunsub: t('mail.prevUnsubscribed'),
			duplicates: t('default.duplicates'),
			prevBounce: t('mail.prevBounce'),
			invalidEmail: t('mail.invalidEmail'),
			all: t('default.all'),
			allLinks: t('default.allLinks')
		};
	},

	renderFilterBtn: function (key, text, checked) {
		var className = 'btn up-btn btn-sm no-border';
		if (checked) {
			className += ' btn-white-grey';
		} else {
			className += ' btn-light-grey no-shadow';
		}

		var btn = (
			<button className={className} onClick={this.props.onFilterChange.bind(this, key, !checked)}>
				{' '}
				{text}{' '}
			</button>
		);

		return (
			<Tooltip title={text} position="top" key={key}>
				{btn}
			</Tooltip>
		);
	},

	setDeliveredGroup: function (deliveredGroup) {
		this.props.onFilterChange('deliveredGroup', deliveredGroup);
	},

	handleChangeUrl: function (e) {
		var selectdLink = _.find(this.props.clickedUrls, { id: parseInt(e.target.value) });
		this.props.onChangeUrl(selectdLink.name);
	},

	render: function () {
		var deliveredClass = 'btn-group';
		var undeliveredClass = 'btn-group undelivered';
		if (this.props.filters.deliveredGroup) {
			deliveredClass += ' active-group';
		} else {
			undeliveredClass += ' active-group';
		}

		var numberFormat = this.props.tools.$filter('numberFormat');
		var delivered = this.props.delivered ? numberFormat(this.props.delivered) : 0;
		var undelivered = this.props.undelivered ? numberFormat(this.props.undelivered) : 0;

		var className = 'btn up-btn btn-sm no-border';

		var activeFilters = _.filter(this.props.filters, function (f, k) {
			return f && k !== 'deliveredGroup';
		});
		if (!activeFilters.length) {
			className += ' btn-white-blue';
		} else {
			className += ' btn-light-grey no-shadow';
		}
		return (
			<div style={{ marginTop: '10px' }}>
				<Row>
					<Column>
						<div className={deliveredClass}>
							<button className={className} onClick={this.props.onFilterChange.bind(this, 'all', true)}>
								{' '}
								{this.lang.all}{' '}
							</button>
							{this.renderFilterBtn('open', this.lang.opened, this.props.filters.open)}
							{this.renderFilterBtn('click', this.lang.clicked, this.props.filters.click)}
							<button
								key="delivered"
								onClick={this.setDeliveredGroup.bind(this, true)}
								className="group-trigger btn up-btn btn-sm btn-green no-shadow no-border"
							>
								{this.lang.delivered} {delivered}
							</button>
							{this.renderFilterBtn('submit', this.lang.submits, this.props.filters.submit)}
							{this.renderFilterBtn('unsub', this.lang.unsubs, this.props.filters.unsub)}
						</div>

						<div className={undeliveredClass}>
							<button className={className} onClick={this.props.onFilterChange.bind(this, 'all', true)}>
								{' '}
								{this.lang.all}{' '}
							</button>
							{this.renderFilterBtn('duplicates', this.lang.duplicates, this.props.filters.duplicates)}
							{this.renderFilterBtn('bounce', this.lang.bounce, this.props.filters.bounce)}
							{this.renderFilterBtn('prevbounce', this.lang.prevBounce, this.props.filters.prevbounce)}
							<button
								key="undelivered"
								onClick={this.setDeliveredGroup.bind(this, false)}
								className="group-trigger btn up-btn btn-sm btn-green no-shadow no-border"
							>
								{this.lang.notDelivered} {undelivered}
							</button>
							{this.renderFilterBtn('prevunsub', this.lang.prevunsub, this.props.filters.prevunsub)}
							{this.renderFilterBtn(
								'invalidemail',
								this.lang.invalidEmail,
								this.props.filters.invalidemail
							)}
						</div>

						{this.props.filters.click ? (
							<div className={undeliveredClass} style={{ width: '30%' }}>
								<UpSelect
									className="form-control"
									data={this.props.clickedUrls}
									defaultValue={{
										id: 0,
										name:
											this.props.selectedLink != null
												? this.props.selectedLink
												: this.lang.allLinks
									}}
									required={true}
									onChange={this.handleChangeUrl}
								/>
							</div>
						) : null}
					</Column>
					{this.props.numRetryableErrors && !this.props.filters.deliveredGroup ? (
						<Column align="right" fixedWidth={180}>
							<ThirdButton onClick={this.props.onRetryErrors} disabled={this.props.retryingErrors}>
								<Icon name="refresh" space="mrs" spin={this.props.retryingErrors} />
								{T('mailCampaign.retryXFailedEmails', { value: this.props.numRetryableErrors })}
							</ThirdButton>
						</Column>
					) : null}
				</Row>
			</div>
		);
	}
});

// Registrations STAY. root.jsx resolves the page by computed key
// (ReactTemplates.mailCampaign[props.pageComponent]) and pages/dashboard.jsx resolves its stat
// widgets by an assembled key (o.entity + o.type), so no key in this namespace can be shown to be
// unreachable. Through `window.` and creating the objects if absent, so importing any of these
// never depends on the global already existing -- the break WEB-9510 had to fix for elevio.
window.ReactTemplates = window.ReactTemplates || {};
window.ReactTemplates.mailCampaign = window.ReactTemplates.mailCampaign || {};
window.ReactTemplates.mailCampaign.recipientFilters = RecipientFilters;

export { RecipientFilters as recipientFilters };
